import React, { useState, useEffect, Fragment } from "react";
import { Dashboards } from "../../../components/backgrounds/Dashboards";
import { useNavigate, useLocation } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Delete, Edit } from "../../../components/buttons/Crud";
import { validateSessionAndJwtToken } from "../../../utils/validateTokenSession";
import { AddBankAccountDialog } from "../../../components/dialogs/addBankAccount.dialog";
import { BancoPageService } from "./bancoPage.service";
import { SkeletonDahsboard } from "../../../components/skeleton/skeletonDash";
import { BasicInfoService } from "../../../services/basicinfo/basicinfo.service";
import { ModalConfirmDelete } from "../../../components/modals/ModalConfirmDelete";
import { ModalConfirm } from "../../../components/modals/ModalConfirm";
import { ErrorAlert } from "../../../components/alerts/errorAlert";
import { returnToSignin } from "../../../utils/returnToSign";
import { DashboardMyCredit } from "../../../components/backgrounds/DashboardMyCredit";
import { useCredit } from "../../../context/creditContext";
import { EditBankAccountDialog } from "../../../components/dialogs/editBankAccountDialog";
import { SuccessAlert } from "../../../components/alerts/successAlert";

const bancoPageService = new BancoPageService();

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function BancoPage() {
  const { disclosures, creditInfo, due } = useCredit();
  let { state } = useLocation();
  let navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const [openDialogEdit, setOpenDialogEdit] = useState(false);
  const [openDialogConfirm, setOpenDialogConfirm] = useState(false);
  const [bancAccount, setBancAccount] = useState({
    bankAccount: "",
    typeBankAccount: "",
    accountNumber: "",
    parent: false,
  });
  const [accountToEdit, setAccountToEdit] = useState({});
  const [accounts, setAccounts] = useState([]);
  const [features, setFeatures] = useState([]);
  const [numAccountsArrayHide, setNumAccountsArrayHide] = useState([]);
  const [numAccountsArrayCompleted, setNumAccountsArrayCompleted] = useState(
    []
  );
  const [numAccountsArray, setNumAccountsArray] = useState([]);
  const [accountBooleanShowIcon, setAccountBooleanShowIcon] = useState([]);
  const [showButtonAdd, setShowButtonAdd] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [idAccount, setIdAccount] = useState("");
  const [addMainAccount, setAddMainAccount] = useState(false);
  const [viewalert, setViewalert] = useState(false);
  const [messsageAlert, setMessageAlert] = useState("");
  const [isOpenError, setIsOpenError] = useState(false);
  const [isOpenSuccess, setIsOpenSuccess] = useState(false);
  const [name, setName] = useState("");
  const [balance, setBalance] = useState("");

  const handleToggle = (index) => {
    if (accountBooleanShowIcon[index]) {
      const updatedArray = [...numAccountsArrayHide];
      updatedArray.splice(index, 1, numAccountsArrayHide[index]);
      setNumAccountsArray(updatedArray);
    } else {
      const updatedArray = [...numAccountsArrayHide];
      updatedArray.splice(index, 1, numAccountsArrayCompleted[index]);
      setNumAccountsArray(updatedArray);
    }

    const ArrayShowIcon = [...accountBooleanShowIcon];
    ArrayShowIcon.splice(index, 1, !accountBooleanShowIcon[index]);
    setAccountBooleanShowIcon(ArrayShowIcon);
  };

  const handleOpenDialogAddAccount = (e) => {
    e.preventDefault();
    setOpenDialog(true);
  };

  const handleOpenDialogEditAccount = (id) => {
    setIdAccount(id);
    let accountToEdit = accounts.filter((ac) => ac?.id === id)[0];
    setAccountToEdit(accountToEdit);
    setOpenDialogEdit(true);
  };

  const handleOpenAlert = (type, message, isOpen) => {
    if (type === "error") {
      setMessageAlert(message);
      setIsOpenError(isOpen);
      setViewalert(isOpen);
    } else if (type === "success") {
      setMessageAlert(message);
      setIsOpenSuccess(isOpen);
      setViewalert(isOpen);
    }
    setTimeout(() => {
      setMessageAlert("");
      setIsOpenError(false);
      setViewalert(false);
    }, 5000);
  };

  const refreshAccounts = async () => {
    let _accounts = await bancoPageService.loadAccounts();
    if (_accounts.length >= 4) {
      setShowButtonAdd(false);
    } else {
      setShowButtonAdd(true);
    }
    bancoPageService.mapAccounts(_accounts, {
      setNumAccountsArray,
      setNumAccountsArrayHide,
      setNumAccountsArrayCompleted,
      setFeatures,
      setAccountBooleanShowIcon,
    });
    setAccounts(_accounts);
  };

  const updateAddMainAccount = (hasAddMainAccount) => {
    setAddMainAccount(hasAddMainAccount);
  };

  const deleteAccount = async (id) => {
    try {
      let payload = {
        id,
        doc: localStorage.getItem("doc"),
      };
      await BasicInfoService.deleteBankAccount(payload.doc, payload.id);
      refreshAccounts();
    } catch (error) {
      console.error(error);
    }
  };

  const changePrincipalAccount = async (id) => {
    try {
      let accountSelected = accounts.filter((acc) => acc.id === id)[0];
      let payload = {
        bankAccount: accountSelected,
        doc: localStorage.getItem("doc"),
      };
      /* if (!addMainAccount) {
        handleOpenAlert(
          "error",
          "No puede agregar una cuenta como principal mientras tengas un crédito vigente.",
          true
        );
        return;
      } */
      await BasicInfoService.changePrincipalBankAccount(payload);
      refreshAccounts();
    } catch (error) {
      console.error(error);
    }
  };

  const toggleDialogDelete = (id) => {
    setIdAccount(id);
    setOpenDialogDelete(!openDialogDelete);
    return;
  };

  const toggleDialogConfirm = (id) => {
    setIdAccount(id);
    setOpenDialogConfirm(!openDialogConfirm);
    return;
  };

  useEffect(() => {
    const docSession = localStorage.getItem("doc");
    const validSessionAndTokenJwt = async () => {
      try {
        let isValidToken = await validateSessionAndJwtToken();
        return isValidToken;
      } catch (error) {
        return false;
      }
    };
    const loadBankAccounts = async () => {
      let info = await bancoPageService.loadAccounts();
      return info;
    };

    if (state) {
      if (state?.name) {
        setName(state?.name);
      }
      if (state?.balance) {
        setBalance(state?.balance);
      }
    }

    validSessionAndTokenJwt()
      .then(async (isValidToken) => {
        if (isValidToken) {
          try {
            let _accounts = await loadBankAccounts();
            if (_accounts.length === 0) {
              let basicInfo = await bancoPageService.loadBasicInfo();
              if (Object.keys(basicInfo).length > 0) {
                let account = {
                  bankAccount: basicInfo?.bankAccount,
                  typeBankAccount: basicInfo?.typeBankAccount,
                  accountNumber: basicInfo?.accountNumber,
                  parent: true,
                };
                bancoPageService.mapAccounts([account], {
                  setNumAccountsArray,
                  setNumAccountsArrayHide,
                  setNumAccountsArrayCompleted,
                  setFeatures,
                  setAccountBooleanShowIcon,
                });
              }
            } else {
              bancoPageService.mapAccounts(_accounts, {
                setNumAccountsArray,
                setNumAccountsArrayHide,
                setNumAccountsArrayCompleted,
                setFeatures,
                setAccountBooleanShowIcon,
              });
            }

            if (_accounts.length === 4) {
              setShowButtonAdd(false);
            }
            setAccounts(_accounts);
            await bancoPageService.determineAddMainAccount(
              docSession,
              updateAddMainAccount
            );
            setIsLoading(false);
          } catch (error) {
            console.log(error);
            localStorage.removeItem("doc");
            localStorage.setItem("is_signin", false);
            return navigate("/ingresar");
          }
        } else {
          returnToSignin(navigate);
        }
      })
      .catch((e) => {
        console.log(e);
        returnToSignin(navigate);
      });
  }, []);

  if (isLoading) {
    return (
      <Fragment>
        <DashboardMyCredit
          name={"Cargando"}
          balance={""}
          current={"4"}
          title={"Mis bancos"}
          main={
            <>
              <div className="pt-4 px-6 lg:px-0">
                Elige el banco donde quieres recibir tus créditos de Galilea
              </div>
              <div className="py-6 grid grid-cols-8 gap-4 px-6 lg:px-0">
                <div className="relative col-span-8 md:col-span-4 grid content-between h-full rounded-2xl transition p-4 bg-white">
                  <div className="flex justify-between">
                    <SkeletonDahsboard height={25} width={80} />
                  </div>

                  <div className="absolute w-6 h-6 rounded-full right-4 top-4">
                    <SkeletonDahsboard
                      variant={"circular"}
                      height={20}
                      width={20}
                    />
                  </div>

                  <div className="pb-4">
                    {/* La parte de detalles */}

                    <div>
                      <div className="py-0 md:grid grid-cols-8 pt-3">
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={40} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={90} />
                        </div>
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={110} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={50} />
                        </div>
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={130} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={90} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end space-x-4">
                    <Delete />
                    <Edit />
                  </div>
                </div>
                <div className="relative col-span-8 md:col-span-4 grid content-between h-full rounded-2xl transition p-4 bg-white">
                  <div className="flex justify-between">
                    <SkeletonDahsboard height={25} width={80} />
                  </div>

                  <div className="absolute w-6 h-6 rounded-full right-4 top-4">
                    <SkeletonDahsboard
                      variant={"circular"}
                      height={20}
                      width={20}
                    />
                  </div>

                  <div className="pb-4">
                    {/* La parte de detalles */}

                    <div>
                      <div className="py-0 md:grid grid-cols-8 pt-3">
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={40} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={90} />
                        </div>
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={110} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={50} />
                        </div>
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={130} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={90} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end space-x-4">
                    <Delete />
                    <Edit />
                  </div>
                </div>
                <div className="relative col-span-8 md:col-span-4 grid content-between h-full rounded-2xl transition p-4 bg-white">
                  <div className="flex justify-between">
                    <SkeletonDahsboard height={25} width={80} />
                  </div>

                  <div className="absolute w-6 h-6 rounded-full right-4 top-4">
                    <SkeletonDahsboard
                      variant={"circular"}
                      height={20}
                      width={20}
                    />
                  </div>

                  <div className="pb-4">
                    {/* La parte de detalles */}

                    <div>
                      <div className="py-0 md:grid grid-cols-8 pt-3">
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={40} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={90} />
                        </div>
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={110} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={50} />
                        </div>
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={130} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={90} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end space-x-4">
                    <Delete />
                    <Edit />
                  </div>
                </div>
                <div className="relative col-span-8 md:col-span-4 grid content-between h-full rounded-2xl transition p-4 bg-white">
                  <div className="flex justify-between">
                    <SkeletonDahsboard height={25} width={80} />
                  </div>

                  <div className="absolute w-6 h-6 rounded-full right-4 top-4">
                    <SkeletonDahsboard
                      variant={"circular"}
                      height={20}
                      width={20}
                    />
                  </div>

                  <div className="pb-4">
                    {/* La parte de detalles */}

                    <div>
                      <div className="py-0 md:grid grid-cols-8 pt-3">
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={40} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={90} />
                        </div>
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={110} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={50} />
                        </div>
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={130} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={90} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end space-x-4">
                    <Delete />
                    <Edit />
                  </div>
                </div>
              </div>
            </>
          }
        />
      </Fragment>
    );
  }

  return (
    <Fragment>
      {viewalert && (
        <>
          <ErrorAlert
            isOpen={isOpenError}
            message={messsageAlert}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          />
          <SuccessAlert
            isOpen={isOpenSuccess}
            message={messsageAlert}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          />
        </>
      )}
      <DashboardMyCredit
        name={name ?? ""}
        balance={balance ?? ""}
        current={"4"}
        title={"Mis bancos"}
        disclosures={disclosures}
        creditInfo={creditInfo}
        due={due}
        main={
          <>
            {openDialog && (
              <AddBankAccountDialog
                dialogOpen={openDialog}
                setDialogOpen={setOpenDialog}
                _state={bancAccount}
                setState={setBancAccount}
                refreshAccounts={refreshAccounts}
                addMainAccount={addMainAccount}
                features={features}
                handleOpenAlert={handleOpenAlert}
              />
            )}

            {openDialogEdit && (
              <EditBankAccountDialog
                dialogOpen={openDialogEdit}
                setDialogOpen={setOpenDialogEdit}
                _state={bancAccount}
                setState={setBancAccount}
                refreshAccounts={refreshAccounts}
                addMainAccount={addMainAccount}
                features={features}
                accountToEdit={accountToEdit}
                handleOpenAlert={handleOpenAlert}
              />
            )}

            {openDialogDelete && (
              <ModalConfirmDelete
                isOpen={openDialogDelete}
                messageTitle={"esta cuenta?"}
                toggleDialogDelete={toggleDialogDelete}
                action={deleteAccount}
                idAccount={idAccount}
              />
            )}

            {openDialogConfirm && (
              <ModalConfirm
                isOpen={openDialogConfirm}
                messageTitle={
                  "¿Estás seguro que quieres seleccionar esta cuenta para tus futuros desembolsos?"
                }
                toggleDialogConfirm={toggleDialogConfirm}
                action={changePrincipalAccount}
                idAccount={idAccount}
                msgPrimary={"Sí, estoy seguro"}
                msgSecundary={"Aún no"}
              />
            )}
            <div className="pt-4 px-6 lg:px-0">
              Elige el banco donde quieres recibir tus créditos de Galilea. Puedes guardar hasta 4 bancos.
            </div>
            <div className="py-6 grid grid-cols-8 gap-4 px-6 lg:px-0 mb-32 md:mb-0">
              {features.map((feature, index) => (
                <div
                  key={feature.id}
                  className={
                    "relative col-span-8 md:col-span-4 grid content-between h-full rounded-2xl transition p-4 bg-white"
                  }
                >
                  <div key={index} className="flex justify-between">
                    <div className="text-lg font-bold">{feature.title}</div>
                  </div>

                 {/*  <Tooltip
                    style={{
                      fontWeight: "bolder",
                      fontFamily: "GT Walsheim Pro",
                    }}
                    title="Cambiar a cuenta principal"
                  >
                    <div
                      onClick={() => toggleDialogConfirm(feature.id)}
                      className="absolute bg-purpleLight w-6 h-6 rounded-full right-4 top-4 hover:bg-grayP hover:opacity-20 cursor-pointer"
                    ></div>
                  </Tooltip> */}

                  <div
                    className={classNames(
                      feature.check === true
                        ? "absolute bg-green w-6 h-6 rounded-full right-4 top-4"
                        : "hidden"
                    )}
                  >
                    {feature.check && (
                      <CheckCircleIcon color="white"></CheckCircleIcon>
                    )}
                  </div>

                  <div className="pb-4 pt-2">
                    {/* La parte de detalles */}

                    {feature.details.map((detail, i) => (
                      <div key={i}>
                        <div className="py-0 md:grid grid-cols-8">
                          <span className="col-span-4 text-base text-grayP md:text-base">
                            {detail.name}{" "}
                          </span>
                          <div className="col-span-4 flex">
                            {detail.name.includes("Número") ? (
                              <>
                                <div>{numAccountsArray[index]}</div>
                                <div
                                  key={index}
                                  className="ml-2 pt-1 eyeicon-account"
                                  onClick={() => handleToggle(index)}
                                >
                                  {accountBooleanShowIcon[index]
                                    ? detail.iconHide
                                    : detail.iconShow}
                                </div>
                              </>
                            ) : (
                              <div>{detail.value}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="flex justify-end space-x-4">
                    <Delete
                      id={feature.id}
                      text={feature.deleteBut}
                      disabled={feature.check}
                      handleClick={toggleDialogDelete}
                    />
                    {
                      feature.title === 'Secundaria' &&
                      (
                        <Edit
                          id={feature.id}
                          text={feature.editBut}
                          handleClick={handleOpenDialogEditAccount}
                        />
                      )
                    }
                  </div>
                </div>
              ))}
              {showButtonAdd && (
                <a
                  href="/"
                  onClick={handleOpenDialogAddAccount}
                  className="text-xl min-h-40 border-dashed border-2 rounded-3xl col-span-8 md:col-span-4 text-center grid content-center text-tgray font-bold py-6"
                >
                  <span>Agregar cuenta bancaria +</span>
                </a>
              )}
            </div>
          </>
        }
      />
    </Fragment>
  );
}
